// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import {
  APIResource,
  type RequestOptions,
  type WithResponse,
} from "../../core";
import type { Receipt } from "../../types";
export type GetReceiptQueryParams = {
  mid: string;
  tx_event_id?: number;
};

/**
 * API resource for the Receipts endpoints.
 *
 * The Receipts model obtains receipt-like details for specific transactions.
 */
export class Receipts extends APIResource {
  /**
   * Retrieves receipt specific data for a transaction.
   */
  get(
    id: string,
    query: GetReceiptQueryParams,
    options?: RequestOptions,
  ): Promise<Receipt> {
    return this._client.get<Receipt>({
      path: `/v1.1/receipts/${id}`,
      query,
      ...options,
    });
  }

  getWithResponse(
    id: string,
    query: GetReceiptQueryParams,
    options?: RequestOptions,
  ): Promise<WithResponse<Receipt>> {
    return this._client.getWithResponse<Receipt>({
      path: `/v1.1/receipts/${id}`,
      query,
      ...options,
    });
  }
}
